import React, { useEffect, useState } from "react";
import {
  Typography,
  CircularProgress,
  Card,
  CardContent,
  Button,
  Grid2,
  Badge,
  Backdrop,
} from "@mui/material";
import Layout from "../components/Layout";
import { getAllCourses, getAllUviForAdmin } from "../service/service"; // Import the service function
import { Link } from "react-router-dom";

const ReviewVoiceNotes = () => {
  const [courses, setCourses] = useState([]);
  const [uviCounts, setUviCounts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true); // Start loading
      try {
        const data = await getAllCourses(); // Call the service function
        setCourses(data.data); // Set courses in state
      } catch (error) {
        console.error("Failed to fetch courses:", error);
      } finally {
        setLoading(false); // Stop loading
      }
    };

    fetchCourses(); // Fetch courses when the component mounts
  }, []);

  // Fetch UVI counts and update the badge when courses change
  useEffect(() => {
    if (!courses.length) return;

    const fetchAllUvi = async () => {
      try {
        // Create an object mapping course IDs to their UVI counts
        const counts = Object.fromEntries(
          await Promise.all(
            courses.map(async (course) => [
              course._id,
              (await getAllUviForAdmin(course._id, course.name)).length,
            ]),
          ),
        );
        setUviCounts(counts);
      } catch (error) {
        console.error("Failed to fetch UVIs:", error);
      }
    };

    fetchAllUvi();
  }, [courses]);

  return (
    <Layout>
      {loading ? ( // Show loading indicator
        <Backdrop open={loading} sx={{ zIndex: 1 }}>
          <CircularProgress />
        </Backdrop>
      ) : (
        <Grid2 container spacing={2}>
          {courses.map((course) => (
            <Grid2 item size={{ sx: 12, sm: 6, md: 4 }} key={course._id}>
              <Badge badgeContent={uviCounts[course._id] || 0} color="secondary" sx={{ width: "100%" }}>
                <Card sx={{ width: "100%" }}>
                  <CardContent>
                    <Typography variant="h5">{course.name}</Typography>
                    {/* Adjust according to your course structure */}
                    <Typography variant="body2">
                      {course.description}
                    </Typography>
                    {/* Adjust according to your course structure */}
                    <Button
                      variant="contained"
                      color="primary"
                      component={Link}
                      to={`/voice-notes/${course._id}/${course.name}`}
                      sx={{ marginTop: "16px" }}
                    >
                      View Voice Notes
                    </Button>
                  </CardContent>
                </Card>
              </Badge>
            </Grid2>
          ))}
        </Grid2>
      )}
    </Layout>
  );
};

export default ReviewVoiceNotes;
